import React, { Component } from "react";
import {
  Route,
  Link,
  withRouter,
  Switch,
  Redirect,
  NavLink
} from "react-router-dom";
import { inject, observer } from "mobx-react";
import Home from "./Home";
import Shop from "./Shop";
import SingleProduct from "./SingleProduct";
import Cart from "./Cart";
import Login from "./Login";
import Register from "./Register";
import Admin from "./Admin";
import Account from "./Account";
import Order from "./Order";
import LocationPage from "./Location";
import LearnMore from "./Learn";
import Terms from "./terms";
import Contact from "./Contact";
import DownloadsShop from "./DownloadsShop";
import localForage from "localforage";
import { ToastContainer, toast } from "react-toastify";
import logo from "../img/stareway-blue.png";
import logoSm from "../img/stareway.png";
import "../css/App.css";
@inject("UserStore", "CartStore")
@observer
class App extends Component {
  state = {
    mobOpen: false
  };
  componentDidMount() {
    this.props.UserStore.getMyStats();
    localForage.getItem("cart").then(items => {
      this.props.CartStore.setCart(items);
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    return (
      <div className="App">
        <ToastContainer position={toast.POSITION.BOTTOM_RIGHT} />
        <nav>
          <div className="logo-holder">
            <img src={logo} alt="" />
          </div>
          <div className="nav-links">
            <NavLink exact activeClassName="active-page" to="/">
              HOME
            </NavLink>{" "}
            <div className="nav-sep" />
            <NavLink exact activeClassName="active-page" to="/shop">
              EQUIPMENT
            </NavLink>{" "}
            <div className="nav-sep" />
            <NavLink exact activeClassName="active-page" to="/downloads">
              DOWNLOADS
            </NavLink>{" "}
            {/* <div className="nav-sep" />
            <a
              href="https://starewayfilms.wixsite.com/website"
              target="_blank"
              rel="noopener noreferrer"
            >
              BLOG
            </a> */}

              {/* Edited Out the Blog Part to maybe build it later in a better way. I find it unnecessary right now. */}

            {/* <div className="nav-sep" />
            <a
              href="http://courses.starewayfilms.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              COURSES
            </a> */}

            {/* Edited Out the Courses Part to maybe build it later in a better way. */}
            <div className="nav-sep" />
            <NavLink exact activeClassName="active-page" to="/location">
              PICKUP LOCATIONS
            </NavLink>
            {this.props.UserStore.user._id
              ? [
                  <div className="nav-sep" key={1} />,
                  <NavLink
                    exact
                    activeClassName="active-page"
                    key={2}
                    to="/account"
                  >
                    ACCOUNT
                  </NavLink>
                ]
              : [null]}
            {this.props.UserStore.user.admin
              ? [
                  <div className="nav-sep" key={1} />,
                  <NavLink
                    exact
                    activeClassName="active-page"
                    key={2}
                    to="/admin"
                  >
                    ADMIN
                  </NavLink>
                ]
              : null}
            <div className="nav-sep" />
            {this.props.UserStore.user.username ? (
              <span onClick={() => this.props.UserStore.logout()}>LOGOUT</span>
            ) : (
              <NavLink exact activeClassName="active-page" to="/login">
                LOGIN
              </NavLink>
            )}
            <NavLink
              exact
              activeClassName="active-page"
              className="cart-page-link"
              to="/cart"
            >
              <div className="cart">
                <div className="count">{this.props.CartStore.items.length}</div>
                <i className="fa fa-shopping-cart" />
              </div>
            </NavLink>
          </div>
          <i
            className="fa fa-bars"
            onClick={e => {
              this.setState({
                mobOpen: !this.state.mobOpen
              });
            }}
          />
        </nav>
        <div
          className={"mob-nav" + (this.state.mobOpen ? " expanded" : "")}
          onClick={e => {
            this.setState({
              mobOpen: !this.state.mobOpen
            });
          }}
        >
          <img src={logoSm} alt="" />
          <div className="mob-links">
            <NavLink exact activeClassName="active-page" to="/cart">
              <i className="fa fa-shopping-cart" /> CART
            </NavLink>
            <NavLink exact activeClassName="active-page" to="/">
              <i className="fa fa-home" /> HOME
            </NavLink>
            <NavLink exact activeClassName="active-page" to="/shop">
              <i className="fa fa-camera" /> EQUIPMENT
            </NavLink>
            <a
              href="https://starewayfilms.wixsite.com/website"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-rss" /> BLOG
            </a>
            <NavLink exact activeClassName="active-page" to="/location">
              <i className="fa fa-truck" /> PICKUP LOCATIONS
            </NavLink>
            <NavLink exact activeClassName="active-page" to="/contact">
              <i className="fa fa-info" /> CONTACT US
            </NavLink>
            {this.props.UserStore.user._id ? (
              <NavLink exact activeClassName="active-page" to="/account">
                <i className="fa fa-lock" /> ACCOUNT
              </NavLink>
            ) : null}
            {this.props.UserStore.user.admin ? (
              <NavLink exact activeClassName="active-page" to="/admin">
                <i className="fa fa-lock" /> Admin panel
              </NavLink>
            ) : null}
            {this.props.UserStore.user.username ? (
              <a onClick={() => this.props.UserStore.logout()}>
                <i className="fa fa-sign-out" /> LOGOUT
              </a>
            ) : (
              <NavLink exact activeClassName="active-page" to="/login">
                <i className="fa fa-sign-in" /> LOGIN
              </NavLink>
            )}
          </div>
        </div>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/downloads" component={DownloadsShop} />
          <Route exact path="/shop" component={Shop} />
          <Route exact path="/shop/category/:category" component={Shop} />
          <Route exact path="/shop/:id" component={SingleProduct} />
          <Route exact path="/cart" component={Cart} />
          <Route exact path="/account" component={Account} />
          <Route exact path="/orders/:id" component={Order} />
          <Route
            exact
            path="/account/downloads"
            component={props => <Account {...props} defaultTab="downloads" />}
          />
          <Route exact path="/location" component={LocationPage} />
          <Route exact path="/about" component={LearnMore} />
          <Route exact path="/terms" component={Terms} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
          {this.props.UserStore.user ? (
            <Route exact path="/account" component={Account} />
          ) : null}
          {this.props.UserStore.user.admin ? (
            <Route
              exact
              path="/admin/orders/:id"
              component={props => <Order {...props} admin={true} />}
            />
          ) : null}
          {this.props.UserStore.user.admin ? (
            <Route
              exact
              path="/admin/account/:id"
              component={props => <Account {...props} admin={true} />}
            />
          ) : null}
          {this.props.UserStore.user.admin ? (
            <Route exact path="/admin" component={Admin} />
          ) : null}
          {this.props.UserStore.user.username ? <Redirect to="/" /> : null}
        </Switch>
        {/* <div className="semi-footer">
          <div className="links-group">
            <p className="links-title">Site Pages</p>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
          </div>
          <div className="links-group">
            <p className="links-title">Group</p>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
          </div>
          <div className="links-group">
            <p className="links-title">Group</p>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
          </div>
          <div className="links-group">
            <p className="links-title">Group</p>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
          </div>
          <div className="links-group">
            <p className="links-title">Group</p>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
            <a href="http://">Link Goes Here</a>
          </div>
        </div> */}
        <footer>
          <div className="left-side">
            <p>© 2021 Stareway</p> <Link to="/terms">Terms of use</Link>
            {/* <a href="http://">Privacy Policy</a> */}
            <a href="https://www.facebook.com/starewayfilms/">
              <i className="fa fa-facebook-square" />
            </a>
            <a href="https://www.youtube.com/channel/UCHMg1QYji6wm6j3EZfQ8PuA">
              <i className="fa fa-youtube-play" />
            </a>
            <a href="https://vimeo.com/user89783512">
              <i className="fa fa-vimeo-square" />
            </a>
          </div>
          <div className="footer-logo">
            <img src={logo} alt="" />
          </div>
        </footer>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js